module.exports = __webpack_public_path__ + "img/bifold-easel.9fe48a64.jpg";